export const CHECKOUT_URL = "https://rhinoplanner-en.impultienda.ar/checkout/";

export const images = {
  main: "https://cdn.magicpatterns.com/uploads/gWuYM8HfZLsMuu8BaQptYS/RHINOPLANNER-EN.png",
  creator: "https://cdn.magicpatterns.com/uploads/4meeJVa1CPg4CBogLuma2x/Ethan_Whitmore_-_RHINOPLASTY.png",
};

export const stats = [
  { value: "+6", label: "Premium planning volumes" },
  { value: "+20", label: "Worksheets & templates" },
  { value: "+5", label: "Exclusive bonuses" },
  { value: "10 MIN", label: "Structured case review target" },
];

export const beforeItems = [
  "My case analysis is scattered across different notes",
  "I spend too much time deciding what to review first",
  "I forget questions I wanted to investigate",
  "Every case gets documented differently",
  "I have information, but no consistent planning structure",
  "Reviewing a case feels different every time",
];

export const afterItems = [
  "I follow the same structured review sequence",
  "I know what categories to analyze",
  "I document my observations in one place",
  "I organize aesthetic and functional considerations",
  "I create a clearer case-review record",
  "I can review my reasoning after each case",
];

export const needToKnow = [
  "What should I look at first?",
  "What questions should I ask?",
  "What should I document?",
  "How should I organize my observations?",
  "What should I review before moving forward?",
];

export const painPoints = [
  { icon: "compass", text: "I have a case in front of me and don’t know exactly where to begin my analysis." },
  { icon: "timer", text: "I spend too much time jumping between notes, articles, photographs and previous resources." },
  { icon: "brain", text: "I sometimes have observations in my head but no structured way to organize them." },
  { icon: "clipboard", text: "Every case ends up being documented differently." },
  { icon: "search", text: "I want a more systematic way to review facial and nasal characteristics." },
  { icon: "book", text: "After studying a case, I wish I had a better way to capture what I learned." },
];

export const volumes = [
  {
    number: "I",
    title: "The 10-Minute Rhinoplasty Case Review",
    description: "A step-by-step framework that helps me move through a case systematically instead of wondering where to start.",
    items: ["The 10-Minute Review Framework", "Case Setup Sheet", "Initial Observation Checklist", "Priority Identification", "Review Sequence", "Quick Case Summary", "Final Review Page"],
  },
  {
    number: "II",
    title: "Facial Analysis Master Workbook",
    description: "A structured framework for organizing the facial observations that form part of my rhinoplasty case review.",
    items: ["Facial Proportion Worksheet", "Symmetry Review", "Profile Analysis", "Frontal Analysis", "Base View Review", "Facial-Nasal Relationship", "Observation Prompts", "Documentation Sheets"],
  },
  {
    number: "III",
    title: "Nasal Analysis Master Workbook",
    description: "A dedicated workspace for organizing observations related to the nose.",
    items: ["Dorsal Analysis", "Tip Analysis", "Columella Review", "Alar Analysis", "Nasal Base Review", "Profile Review", "Frontal View Review", "Structural Observation Sheets", "Case Notes"],
  },
  {
    number: "IV",
    title: "The Case Planning Blueprint",
    description: "Turn observations into a structured case-planning document.",
    items: ["Case Objectives", "Patient Goals", "Aesthetic Considerations", "Functional Considerations", "Key Questions", "Priority Matrix", "Planning Notes", "Research Questions", "Pre-Case Review"],
  },
  {
    number: "V",
    title: "The Case Documentation System",
    description: "Create a consistent way to record and organize my cases.",
    items: ["Case Cover Sheet", "Patient Goals", "Observation Log", "Photography Review", "Planning Notes", "Questions to Investigate", "Case Timeline", "Follow-Up Notes", "Lessons Learned"],
  },
  {
    number: "VI",
    title: "The Rhinoplasty Case Review Journal",
    description: "The final piece of the system: turning every case into an opportunity for structured reflection and continued professional learning.",
    items: ["What did I observe?", "What did I initially think?", "What questions remained?", "What did I learn?", "What would I review again?", "What patterns did I notice?", "What should I document for future reference?", "Personal Case Library", "Monthly Review", "Progress Tracker"],
  },
];

export const extras = [
  { icon: "file", title: "Structured Case Review Worksheets", text: "Reusable pages that help me organize every case consistently." },
  { icon: "check", title: "Professional Planning Checklists", text: "Quick-reference checklists for the major stages of my case review." },
  { icon: "puzzle", title: "Decision & Question Frameworks", text: "Prompts designed to help me structure what I need to investigate rather than relying on scattered notes." },
  { icon: "grid", title: "Case Analysis Matrices", text: "Visual tools for organizing observations, priorities and questions." },
  { icon: "camera", title: "Photography & Documentation Review Sheets", text: "Structured pages for reviewing and documenting photographic information." },
  { icon: "library", title: "Case Review Templates", text: "Reusable templates that turn the system into a long-term professional reference library." },
];

export const bonuses = [
  {
    number: 1,
    title: "The 50-Question Rhinoplasty Analysis Guide™",
    value: "$27",
    text: "50 structured questions designed to help me slow down, observe more intentionally and organize my case analysis.",
    image: "https://cdn.magicpatterns.com/uploads/kEAfukscY4PxREu5odecq2/BONUS_1_RHINOPLANNER-EN.png",
  },
  {
    number: 2,
    title: "The Rhinoplasty Case Review Checklist™",
    value: "$19",
    text: "A one-page master checklist I can use before, during and after reviewing a case.",
    image: "https://cdn.magicpatterns.com/uploads/vxFUywyrz7J1eDwMNJNuLc/BONUS_2_RHINOPLANNER-EN.png",
  },
  {
    number: 3,
    title: "The Nasal Analysis Quick Reference™",
    value: "$27",
    text: "A visual reference sheet covering the major categories I should remember when reviewing a rhinoplasty case.",
    image: "https://cdn.magicpatterns.com/uploads/vTdCjnhWN9XuDP4qP2S8eN/BONUS_3_RHINOPLANNER-EN.png",
  },
  {
    number: 4,
    title: "The 30-Day Rhinoplasty Analysis Challenge™",
    value: "$37",
    text: "A 30-day guided practice framework with daily observation prompts, questions and reflection exercises.",
    image: "https://cdn.magicpatterns.com/uploads/mNPFSHvrct48sRXk8rDqPF/BONUS_4_RHINOPLANNER-EN.png",
  },
  {
    number: 5,
    title: "The Digital Case Library Template™",
    value: "$17",
    text: "A reusable organizational template that helps me build my own personal library of reviewed cases, observations and learning points.",
    image: "https://cdn.magicpatterns.com/uploads/eADwsBmrgAVNUwTnR2AGoy/BONUS_5_RHINOPLANNER-EN.png",
  },
];

export const guaranteeItems = [
  "Open all 6 volumes",
  "Review the planning worksheets",
  "Use the case-analysis templates",
  "Explore the bonuses",
  "Test the system with my own study workflow",
];

export const testimonials = [
  {
    quote: "I finally have one place where I can organize the different aspects I want to review in a rhinoplasty case.",
    name: "Dr. Elena Rodríguez",
    role: "Plastic Surgeon",
    country: "United States",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/fd241334-501a-4be7-8295-e57df8799835.jpg",
  },
  {
    quote: "The biggest difference for me is having a consistent structure instead of starting from a blank page every time.",
    name: "Dr. Richard Hale",
    role: "Otolaryngologist",
    country: "United Kingdom",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/6a6f1da1-64e5-4f32-ad17-d0b150de64e5.jpg",
  },
  {
    quote: "The case review pages became a useful way for me to document what I observed and what I wanted to study further.",
    name: "Dr. Mei Tanaka",
    role: "Facial Plastic Surgeon",
    country: "Australia",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/8f668684-031c-4ab7-a3d5-2b0cd7ed39ca.jpg",
  },
  {
    quote: "It’s simple, visual and much easier to use than keeping everything in scattered notes.",
    name: "Dr. Omar Haddad",
    role: "Plastic Surgeon",
    country: "Canada",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/72371a3f-4f85-4dbc-b37e-84e7d2c07492.jpg",
  },
];

export const faqs = [
  { q: "How will I receive the material?", a: "Immediately after payment, I’ll receive access instructions for the complete digital collection and all five bonuses." },
  { q: "Is this a surgical training course?", a: "No. The Rhinoplasty Master Planner™ is a professional educational and planning resource. It is not a substitute for formal surgical training, supervised clinical education, institutional protocols or professional judgment." },
  { q: "Who is the planner designed for?", a: "It is designed primarily for qualified plastic surgeons and otolaryngologists who want a structured framework for studying and reviewing rhinoplasty cases." },
  { q: "Do I need to be a rhinoplasty specialist?", a: "The planner is designed for professionals with appropriate medical training and familiarity with rhinoplasty. It does not teach someone how to perform rhinoplasty." },
  { q: "Can I print the worksheets?", a: "Yes. The planner is designed to work as a digital reference and as a printable planning workbook." },
  { q: "Can I use it on a tablet?", a: "Yes. The digital format is designed for convenient tablet use as well as desktop viewing." },
  { q: "Is this a subscription?", a: "No. It is a one-time $27 purchase with lifetime access to the purchased digital materials." },
  { q: "What happens if I don’t like it?", a: "The purchase is protected by the stated 7-day guarantee. Review the materials and decide whether the system fits your workflow." },
  { q: "Does the planner guarantee better surgical results?", a: "No. Surgical outcomes depend on many factors, including individual patient characteristics, clinical judgment, training, technique, anatomy and other circumstances. The planner is an organizational and educational tool." },
];

export const recentBuyers = [
  { name: "Dr. Carlos Méndez", country: "Mexico" },
  { name: "Dra. Valentina Rojas", country: "Colombia" },
  { name: "Dr. Javier Morales", country: "Spain" },
  { name: "Dra. Camila Fernández", country: "Argentina" },
  { name: "Dr. Andrés Castillo", country: "Chile" },
  { name: "Dra. Lucía Herrera", country: "Peru" },
  { name: "Dr. Miguel Torres", country: "Ecuador" },
  { name: "Dra. Sofía Ramírez", country: "Costa Rica" },
  { name: "Dr. Diego Navarro", country: "Uruguay" },
  { name: "Dra. Isabel Gómez", country: "Dominican Republic" },
  { name: "Dr. Alejandro Ruiz", country: "Guatemala" },
  { name: "Dra. Mariana López", country: "Panama" },
];
